<template>
  <b-modal
    cancel-variant="outline-secondary"
    ok-title="Edit"
    title="Edit User"
    :visible="visible"
    @change="val => $emit('update:visible', val)"
    @ok.prevent="handleOk"
  >
    <template v-if="user">

      <validation-observer ref="formRef" #default="{invalid}">
        <b-row>
          <b-col md="12">
            <b-form-group label="Name">
              <validation-provider #default="{ errors }" name="details" rules="required">
                <b-form-input
                  v-model="user.name"
                  :state="errors.length > 0 ? false:null"
                  type="text"
                  placeholder="Name"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Email">
              <validation-provider #default="{ errors }" name="email" rules="required">
                <b-form-input
                  v-model="user.email"
                  :state="errors.length > 0 ? false:null"
                  type="text"
                  placeholder="Email"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Active">
              <validation-provider #default="{ errors }" name="active" rules="required">
                <b-form-checkbox
                  v-model="user.active"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Active"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

      </validation-observer>

      <b-overlay no-wrap :show="loading"/>
    </template>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BModal,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BFormDatepicker,
  BOverlay,
} from 'bootstrap-vue';
import {ValidationObserver, ValidationProvider} from "vee-validate";
import VSelect from "vue-select";

import ToastificationContent from "@core/components/toastification/ToastificationContent";
import VSelectPaginated from '@core/components/v-select-paginated'

import {editUser} from "@/api/user";
import {required} from "@validations";

export default {
  components: {
    BRow,
    BCol,
    BModal,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BFormDatepicker,
    BOverlay,

    VSelect,
    ValidationProvider,
    ValidationObserver,

    VSelectPaginated
  },
  props: {
    visible: Boolean,
    user: Object,
  },
  data() {
    return {
      required,
      loading: false,
    }
  },
  methods: {
    handleOk() {
      this.$refs.formRef.validate().then(async success => {
        if (success) {

          this.loading = true

          try {
            const {message} = await editUser({
              id: this.user.id,
              name: this.user.name,
              email: this.user.email,
              active: this.user.active,
            })

            this.$emit('success');

            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {title: message, icon: 'BellIcon', variant: 'success',},
            })

            this.loading = false

          } catch (e) {

            this.loading = false
            this.$refs.formRef.setErrors(e.errors)

            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {title: e.message, icon: 'AlertTriangleIcon', variant: 'danger',},
            })
          }
        }
      })
    }
  },
}
</script>
